// extracted by mini-css-extract-plugin
export default {"errorMsg":"weather_error-msg_errorMsg"};